/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteConstraintCapacityDtoModel, RouteConstraintCapacityDtoModelType } from "./RouteConstraintCapacityDtoModel"
import { RouteConstraintCapacityDtoModelSelector } from "./RouteConstraintCapacityDtoModel.base"
import { RouteConstraintEndLocationDtoModel, RouteConstraintEndLocationDtoModelType } from "./RouteConstraintEndLocationDtoModel"
import { RouteConstraintEndLocationDtoModelSelector } from "./RouteConstraintEndLocationDtoModel.base"
import { RouteConstraintStartLocationDtoModel, RouteConstraintStartLocationDtoModelType } from "./RouteConstraintStartLocationDtoModel"
import { RouteConstraintStartLocationDtoModelSelector } from "./RouteConstraintStartLocationDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  capacities: IObservableArray<RouteConstraintCapacityDtoModelType>;
}

/**
 * RouteConstraintDtoBase
 * auto generated base class for the model RouteConstraintDtoModel.
 */
export const RouteConstraintDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteConstraintDto')
  .props({
    __typename: types.optional(types.literal("RouteConstraintDto"), "RouteConstraintDto"),
    id: types.identifier,
    routeId: types.union(types.undefined, types.number),
    active: types.union(types.undefined, types.boolean),
    capacity: types.union(types.undefined, types.null, types.number),
    capacities: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => RouteConstraintCapacityDtoModel)))),
    startTime: types.union(types.undefined, types.null, types.string),
    endTime: types.union(types.undefined, types.null, types.string),
    duration: types.union(types.undefined, types.null, types.number),
    startLocations: types.union(types.undefined, types.null, types.array(types.late((): any => RouteConstraintStartLocationDtoModel))),
    endLocations: types.union(types.undefined, types.null, types.array(types.late((): any => RouteConstraintEndLocationDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteConstraintDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeId() { return this.__attr(`routeId`) }
  get active() { return this.__attr(`active`) }
  get capacity() { return this.__attr(`capacity`) }
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
  get duration() { return this.__attr(`duration`) }
  capacities(builder: string | RouteConstraintCapacityDtoModelSelector | ((selector: RouteConstraintCapacityDtoModelSelector) => RouteConstraintCapacityDtoModelSelector) | undefined) { return this.__child(`capacities`, RouteConstraintCapacityDtoModelSelector, builder) }
  startLocations(builder: string | RouteConstraintStartLocationDtoModelSelector | ((selector: RouteConstraintStartLocationDtoModelSelector) => RouteConstraintStartLocationDtoModelSelector) | undefined) { return this.__child(`startLocations`, RouteConstraintStartLocationDtoModelSelector, builder) }
  endLocations(builder: string | RouteConstraintEndLocationDtoModelSelector | ((selector: RouteConstraintEndLocationDtoModelSelector) => RouteConstraintEndLocationDtoModelSelector) | undefined) { return this.__child(`endLocations`, RouteConstraintEndLocationDtoModelSelector, builder) }
}
export function selectFromRouteConstraintDto() {
  return new RouteConstraintDtoModelSelector()
}

export const routeConstraintDtoModelPrimitives = selectFromRouteConstraintDto().routeId.active.capacity.startTime.endTime.duration
